var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLamp = function SvgLamp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "M7.881 17h4.286"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.4,
    d: "M15.087 5.213a5.3 5.3 0 0 1 .411 2.037 5.22 5.22 0 0 1-2.107 4.207 2.4 2.4 0 0 0-.65.732c-.088.152-.158.628-.211 1.09-.062.54-.506.947-1.05.947H9.013c-.538 0-.977-.4-1.04-.934-.055-.466-.128-.952-.218-1.107a2.5 2.5 0 0 0-.654-.735A5.2 5.2 0 0 1 5 7.28c-.015-2.84 2.285-5.21 5.126-5.28a5.25 5.25 0 0 1 4.961 3.212Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "M13.238 6.11a3.24 3.24 0 0 0-1.8-1.76"
  })));
};
export default SvgLamp;